module.exports = __webpack_public_path__ + "img/2.d2b88f05.png";